import React, { useState, useEffect } from 'react';

const initialState = {
    pageState: {
        hasHeader: true,
        hasFooter: false,
        mainTitle: "",
        subTitle: "",
        background: "",
    },
    userData: {
        login_name: "",
        event_id: "",
        user_points: 0,
        user_used_points: 0,
        user_last_points: 0,
        form_name: "",
        form_phone: "",
        form_email: "",
        form_address: "",
        vote_list: [],
        serial_list: [],
        exchange_list: [],
    },
    pageTime:{
        winning: false,
        result: false,
        msg: "",
        msg_type: "",
    },
    menuToggle: false,
    snack: {open: false, theme:'dark', text:''},
    loader: false,
    setPageState: state => {},
    setUserData: state => {},
    setPageTime: state => {},
    setMenuToggle: state => {},
    setSnack: state => {},
    setLoader: state => {},
}

export const GlobalContext = React.createContext(initialState);

export const GlobalProvider = (props) => {
    const [ pageState, setPageState ] = useState(initialState.pageState);
    const [ userData, setUserData ] = useState(initialState.userData);
    const [ pageTime, setPageTime ] = useState(initialState.pageTime);
    const [ menuToggle, setMenuToggle ] = useState(initialState.menuToggle);
    const [ snack, setSnack ] = useState(initialState.snack);
    const [ loader, setLoader ] = useState(initialState.loader);

    return (
        <GlobalContext.Provider value={{
            pageState, userData, pageTime, menuToggle, snack, loader,
            setPageState, setUserData, setPageTime, setMenuToggle, setSnack, setLoader
        }}>
            { props.children }
        </GlobalContext.Provider>
    )
}